import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { TipiTemplateComponent } from 'src/app/admin/tipi-template/tipi-template.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => TipoTemplatePickerComponent) },
  ],
  selector: 'tipo-template-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class TipoTemplatePickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(TipiTemplateComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
